import React from "react";
import "./AboutHero.css";

function AboutHero(props) {
  return (
    <div className="aboutus__item-hero">
      <div className="hero__img">
        <img id="background__heroimg" src="/img/img-0.jpg" />
      </div>
      <div className="hero__details">
        <div className="details__info">
          <h1 className="details__header">Khanyisani</h1>
          <h2 className="details__subHeader">childVision</h2>
          <p className="details__title">Academy</p>
          <i className="details__description">
            'Suppose a brother or a sister is without clothes and daily food. If
            one of you says to them, 'Go in peace; keep warm and well fed,’ but
            does nothing about their physical needs, what good is that? In the
            same way, faith by itself, if it is not accompanied by action, is
            dead.' (James 2:15–17)
          </i>
        </div>
      </div>
    </div>
  );
}

export default AboutHero;
